import { Button } from '@mui/material'
import PropTypes from 'prop-types'

export const ErrorMessage = ({message, children}) => {
    return (
      <div className='loader__error'>
          <strong className='xxxl-text red-text'>Oops!</strong>
          <strong className='xl-text grey-text'>Algo salió mal</strong>
          <br />
          <p className='lg-text grey-text'>{message}</p>
          <br />
          <div className='loader__error--buttons'>
              {children}
          </div>
      </div>
    )
}

export const ErrorWithoutBackButton = ({message, handleAction}) => {
    return (
      <ErrorMessage 
          message={message} 
          handleAction={handleAction}>
          <Button
              variant='text'
              disableElevation
              onClick={handleAction}>
                  Reintentar
          </Button>
      </ErrorMessage>
    )
  }
  
export const ErrorWithBackButton = ({message, handleAction}) => {
    return (
        <ErrorMessage
            message={message}
            hasBackButton
            handleAction={handleAction}>
                <Button
                    variant='text'
                    disableElevation
                    onClick={()=>window.history.back()}>
                        Regresar
                    </Button>
                <Button
                    variant='contained'
                    disableElevation
                    onClick={handleAction}>
                        Reintentar
                </Button>
        </ErrorMessage>
    )
}

export const ErrorNotFoundPage = ({message}) => {
    return (
        <ErrorMessage message={message}>
        <Button
            variant='text'
            disableElevation
            onClick={()=>window.location.back()}>
                Redirigir
            </Button>
        </ErrorMessage>
    )
}

ErrorMessage.propTypes = {
    message: PropTypes.string,
    children: PropTypes.node,
}

ErrorWithoutBackButton.propTypes = {
message: PropTypes.string,
handleAction: PropTypes.func,
}

ErrorWithBackButton.propTypes = {
message: PropTypes.string,
handleAction: PropTypes.func,
}

ErrorNotFoundPage.propTypes = {
message: PropTypes.string,
}